/* eslint-disable max-len */
/**
 * @file 客户路由
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

export default [
  {
    label: '机会',
    key: 'oppotunity_manage',
    breathingLight: () => true,
    disabled: (loginStatus: any) => loginStatus.onlyTechAgency,
    data: [
      {
        label: '创意机会洞察',
        key: 'creative_oppotunity',
        iconClassName: 'icon-nav-oppotunity',
        data: [
          {
            id: 'optimization-creative-script',
            label: '脚本机会',
            href: '/optimization-creative-script',
            enableKey: 'is_enable_optimization_creative',
            isMicroApp: true,
            breathingLight: () => true,
          },
          {
            // id 不能和脚本机会有包含关系
            id: 'optimization-creative-tag',
            label: '标签机会',
            href: '/optimization-creative-tag',
            enableKey: 'is_enable_optimization_creative',
            isMicroApp: true,
          },
          // 2025-10-22 上线创意机会，下线灵感发现入口
          // {
          //   label: '灵感发现',
          //   key: 'inspiration_discovery',
          //   href: '/agency-workspace/assets-tools/material',
          //   path: '/agency-workspace/assets-tools/material',
          //   breathingLight: () => true,
          //   data: [{
          //     id: 'chance_list',
          //     href: '/agency-workspace/assets-tools/material',
          //     label: '大盘优秀脚本推荐',
          //     enableKey: 'is_high_quality_material_enable',
          //     isMicroApp: true,
          //     // disableTabNav: true,
          //     // hideTabNav: true,
          //     // hideSubNav: true,
          //   }],
          // },
        ],
      },
      {
        label: '推广产品机会',
        key: 'product_oppotunity',
        iconClassName: 'icon-nav-product',
        data: [
          {
            id: 'chance_list',
            href: '/agency-workspace/dashboard-chance/list',
            label: '机会洞察',
            enableKey: 'is_diagnose_opportunity_enable',
            data: [
              {
                href: '/agency-workspace/dashboard-chance/list',
                label: '机会详情列表',
                hideTabNav: true,
                isMicroApp: true,
              },
              {
                href: '/agency-workspace/dashboard-chance/customer',
                label: '机会客户列表',
                hideTabNav: true,
                isMicroApp: true,
              },
            ],
          },
          {
            id: 'find-chance',
            href: '/agency-workspace/find-chance',
            label: '主动机会探索',
            enableKey: 'is_opportunity_proactive_enable',
            data: [
              {
                href: '/agency-workspace/find-chance',
                label: '主动机会探索',
                hideTabNav: true,
                isMicroApp: true,
              },
            ],
          },
          {
            id: 'high_potential_recommend',
            href: '/new-product/high-potential/recommend',
            label: '高潜新品推荐',
            enableKey: 'is_product_optimization_enable',
            isMicroApp: true,
          },
        ],
      },
      {
        label: '流量机会',
        key: 'traffic_oppotunity',
        iconClassName: 'icon-nav-traffic-oppotunity',
        data: [
          {
            id: 'traffic_analysis',
            href: '/analysis-traffic',
            label: '流量分析',
            isMicroApp: true,
          },
        ],
      },
      {
        label: '其他',
        key: 'opportunity_other',
        iconClassName: 'icon-nav-strategy',
        data: [
          {
            id: 'diagnose_list',
            href: '/agency/diagnose/list_v3',
            key: 'diagnoseList',
            enableKey: 'is_diagnose_enable',
            purview: 100000000,
            label: '问题诊断',
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/diagnose/list/index'), { fallback: <Loading /> }),
            basePage: true,
            singleTabNav: true,
          },
        ],
      },
    ],
  },
];
